import {
  useState,
  useEffect
} from 'react';
import CharacterShowcase from './components/CharacterShowcase';
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import Header from './components/Header'
import Action from './components/Action'
import Article from './components/Article'
import CharacterList from './character_list.json';
import Title from './images/title_ginasbar.png';
import BigNumber from 'bignumber.js';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import CookieConsent from "react-cookie-consent"

export default function App() {
  const tokenIds = [16, 17, 18, 19, 20, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);

  const [selectedCharacter, setSelectedCharacter] = useState([]);
  const [fewerFlag, setFewerFlag] = useState(false);
  const [lang, setLang] = useState("ja");
  const [loading, setLoading] = useState(false);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MARKETPLACE_LINK: "",
  });

  function toggleLang(lang) {
    setLang(lang);
  }

  function addCharacter(index) {
    const tmp = selectedCharacter;
    setSelectedCharacter([...tmp, index]);
  }

  function removeCharacter(index) {
    console.log(index)
    setSelectedCharacter(selectedCharacter.filter(function (char) {
      return char !== index
    }));
  }

  function allSelect() {
    let tmp = [];
    CharacterList.forEach((el, index) => {
      tmp.push(index);
    });
    setSelectedCharacter(tmp);
    updateFewerFlag(false);
  }

  const mint = async () => {
    if (selectedCharacter.length > 2) {
      let mintMethod = data.phase === '1' ? blockchain.smartContract.methods
        .whitelistMint : blockchain.smartContract.methods
        .mint
      const costWei = await (data.phase === '1' ? blockchain.smartContract.methods
        .getWLPrice(selectedCharacter.length).call() : blockchain.smartContract.methods
          .getPrice(selectedCharacter.length).call())
      const totalCostWei = BigNumber(costWei.toString()).times(BigNumber(selectedCharacter.length.toString())).toString();
      console.log(totalCostWei)
      const mintArgs = selectedCharacter.map(x => tokenIds[x])
      console.log(mintArgs)
      setLoading(true)
      mintMethod(mintArgs)
        .send({
          // gasLimit: String(totalGasLimit),
          to: CONFIG.CONTRACT_ADDRESS,
          from: blockchain.account,
          value: totalCostWei,
        })
        .once("error", (err) => {
          setLoading(false)
          console.log(err);
        })
        .then((receipt) => {
          setLoading(false)
          setSelectedCharacter([])
          console.log(receipt);
          dispatch(fetchData(blockchain.account));
        });
    } else {
      console.log('Please select at least 1-Character.');
      setFewerFlag(true);
    }
  }

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  function updateFewerFlag(bool) {
    setFewerFlag(bool);
  }


  function connectClick(e) {
    e.preventDefault();
    setLoading(true)
    dispatch(connect()).then(setLoading(false));
    getData();
  }
  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      setLoading(true)
      dispatch(fetchData(blockchain.account)).then(() => setLoading(false));
    }
  };


  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  // 言語切替対象の文章
  const tos = (lang === 'ja') ? '利用規約' : 'Term of Use';
  const privacy = (lang === 'ja') ? 'プライバシーポリシー' : 'Privacy Policy';
  const policy = (lang === 'ja') ? '特定商取引法表記' : 'Act on specified commercial transactions';

  return (
    <>
      <Header toggleLang={toggleLang} lang={lang} connectClick={connectClick} />

      <div className="container">
        <main className="main">
          <div className="title">
            <h2>
              <img src={Title} alt="Gina's Bar" />
            </h2>
            <div className="description"><span></span>{lang === 'ja' ? 'キャラクターを仲間にし、冒険に出かけよう！' : 'Hire Characters and go on an Exploration!'}</div>
          </div>

          {/* 左側のキャラ選択部分 */}
          <div className="content">
            <div className="select-characters">
              <h3>Select Characters</h3>
              <CharacterShowcase
                addCharacter={addCharacter}
                removeCharacter={removeCharacter}
                selectedCharacter={selectedCharacter}
                updateFewerFlag={updateFewerFlag}
                CharacterList={CharacterList}
              />
            </div>

            {/* 右側のボタン類 */}
            <Action
              removeCharacter={removeCharacter}
              selectedCharacter={selectedCharacter}
              allSelect={allSelect}
              mint={mint}
              fewerFlag={fewerFlag}
              CharacterList={CharacterList}
              lang={lang}
            />
          </div>
        </main>

        {/* 説明文 */}
        <Article lang={lang} />
      </div>

      <footer className='footer'>
        <CookieConsent style={{ background: "#FFF", color: "#000" }} buttonText="OK" buttonStyle={{ background: "#333333", color: "#ffffff", fontSize: "13px" }}>
          Notice. isekai-battle.xyz uses cookies to provide necessary website functionality, improve your experience and analyze our traffic. By using our website, you agree to our&nbsp;
          <a style={{ color: '#1c9bf0', textDecoration: 'underline' }} href='https://isekai-battle.notion.site/0ce5f66337324f60bda9ce2a70a38ee1'>Privacy Policy</a>&nbsp;and our cookies usage.
        </CookieConsent>
        <ul className='footer__navigation'>
          <li><a href="https://isekai-battle.notion.site/089ec2846284415198978d1df39332ee" target="_blank" rel="noreferrer">{tos}</a></li>
          <li><a href="https://isekai-battle.notion.site/0ce5f66337324f60bda9ce2a70a38ee1" target="_blank" rel="noreferrer">{privacy}</a></li>
          <li><a href="https://isekai-battle.notion.site/a8deb51559754500bfc7db4b247ce08d" target="_blank" rel="noreferrer">{policy}</a></li>
          <li>{lang === 'ja' ?
            <a href="https://isekai-battle.notion.site/WHITEPAPER-JA-faad3266e9ed4d1fbd530ad9d3c4dd37" target="_blank" rel="noreferrer">WhitePaper</a> :
            <a href="https://isekai-battle.notion.site/WHITEPAPER-EN-144fd438527141eea76fbbf7f0063695" target="_blank" rel="noreferrer">WhitePaper</a>
          }</li>
          <li><a href={CONFIG.SCAN_LINK} target="_blank" rel="noreferrer">Etherscan</a></li>
          <li><a href="https://opensea.io/collection/isekai-battle" target="_blank" rel="noreferrer">OpenSea</a></li>
        </ul>
        <p className='footer__copyright'>©2022 Isekai Battle Project</p>
      </footer>

      <Backdrop
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

